// Valori partajate in toata aplicatia — a nu se duplica in componente.

export const COMBUSTIBILI = [
    'Benzină',
    'Diesel',
    'Hybrid',
    'Plug-in Hybrid Benzină',
    'Plug-in Hybrid Motorină',
    'Electric',
    'GPL + Benzină',
];

export const CUTII_VITEZE = ['Automată', 'Manuală'];

export const TRACTIUNI = ['Față', 'Spate', '4x4'];

export const NORME_POLUARE = ['Euro 6', 'Euro 5', 'Euro 4', 'Euro 3', 'Euro 2', 'Euro 1', 'Non-Euro'];

export const STATUS = {
    ACTIV: 'ACTIV',
    INACTIV: 'INACTIV',
};

// Pe carduri variantele lungi de Plug-in Hybrid se scurteaza (altfel se rup pe doua randuri);
// varianta completa (Benzină/Motorină) ramane vizibila in pagina de detalii.
export const combustibilScurt = (combustibil) =>
    combustibil && combustibil.startsWith('Plug-in Hybrid') ? 'Plug-in Hybrid' : combustibil;
